import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IConsultPrepaidDataFormMeta {
    idBank: FormInputMeta;
    nameBank: FormInputMeta;
    PAN: FormInputMeta;
    seq: FormInputMeta;
    cardName: FormInputMeta;
    cardStatus: FormInputMeta;
    agencyId: FormInputMeta;
    agencyName: FormInputMeta;
    clientId: FormInputMeta;
    clientName: FormInputMeta;
    clientStatus: FormInputMeta;
    accountId: FormInputMeta;
    accountName: FormInputMeta;
    accountStatus: FormInputMeta;
    accountBalance: FormInputMeta;
    cardProductId: FormInputMeta;
    cardProductName: FormInputMeta;
    prepaidProductId: FormInputMeta;
    prepaidProductName: FormInputMeta;
    prepaidAppId: FormInputMeta;
    
    schema: any;
  }

const ConsultPrepaidDataFormMeta = {} as IConsultPrepaidDataFormMeta;

ConsultPrepaidDataFormMeta.idBank = {
    name: "idBank",
    label: "ID Banque",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.nameBank = {
    name: "nameBank",
    label: "Raison Sociale",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.PAN = {
    name: "PAN",
    label: "PAN",
    type: "select",
    options: [
        {
          label: 'A',
          value: 'a',
        },
        {
          label: 'D',
          value: 'd',
        },
        {
          label: 'I',
          value: 'i',
        },
        {
          label: 'R',
          value: 'r',
        },
    ],
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.seq = {
    name: "seq",
    label: "Seq",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.cardName = {
    name: "cardName",
    label: "Nom sur la carte",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.cardStatus = {
    name: "cardStatus",
    label: "Statut Carte",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.agencyId = {
    name: "agencyId",
    label: "Agence: ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.agencyName = {
    name: "agencyName",
    label: "Agence: Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.clientId = {
    name: "clientId",
    label: "Client: ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.clientName = {
    name: "clientName",
    label: "Client: Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.clientStatus = {
    name: "clientStatus",
    label: "Client: Statut",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.accountId = {
    name: "accountId",
    label: "Compte: ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.accountName = {
    name: "accountName",
    label: "Compte: Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.accountStatus = {
    name: "accountStatus",
    label: "Compte: Statut",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.accountBalance = {
    name: "accountBalance",
    label: "Compte: Solde",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.cardProductId = {
    name: "cardProductId",
    label: "Produit carte: ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.cardProductName = {
    name: "agencyName",
    label: "Produit carte: Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.prepaidProductId = {
    name: "prepaidProductId",
    label: "Produit prépayé: ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.prepaidProductName = {
    name: "prepaidProductName",
    label: "Produit prépayé: Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ConsultPrepaidDataFormMeta.prepaidAppId = {
    name: "prepaidAppId",
    label: "Application prépayée: Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}

ConsultPrepaidDataFormMeta.schema = yup.object().shape(getValidationSchema(ConsultPrepaidDataFormMeta));

export default ConsultPrepaidDataFormMeta;